var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("router-and-print", {
    attrs: {
      data: _vm.params.data,
      field: _vm.params.field,
      "use-route": _vm.params.useRoute,
      "use-print": _vm.params.usePrint,
      "route-name": _vm.params.routeName,
      "route-param-keys": _vm.params.routeParamKeys,
      "route-title": _vm.params.routeTitle,
      "route-permissions": _vm.params.routePermissions,
      "extra-route-params": _vm.params.extraRouteParams,
      "direct-mode": _vm.params.directMode,
      "direct-url": _vm.params.directUrl,
      "direct-params": _vm.params.directParams,
      "jump-instruction": _vm.params.jumpInstruction,
      "instruction-click": _vm.params.instructionClick,
      "print-method": function() {
        return _vm.params.printMethod(_vm.params.data[_vm.field])
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }